<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
              :placeholder="$t('keyword')"></b-form-input>
            <client-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel" attribute="client"
              @change="load"></client-select>
            <form-select :model="filterFormModel" class="mr-1 mb-1" attribute="type" :options="[
              { value: null, text: $t('selectCustomerType') },
              { value: 'personal', text: $t('personal') },
              { value: 'enterprise', text: $t('enterprise') },
            ]" />
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="sales" :isFilter="true"
              :place-holder="$t('chooseSales')" not-updated-select>
            </admin-user-select>
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="account" :isFilter="true"
              :place-holder="$t('chooseAccount')" not-updated-select>
            </admin-user-select>
            <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="status" :options="statusOptions"
              @change="load"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <k-y-c-export :filter="filterFormModel" :total-count="itemCount"
                  v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)"></k-y-c-export>
                <button @click="$refs.kycForm.create()" class="btn btn-sm btn-success"
                  v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
                  <font-awesome-icon icon="plus" />&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('client') }}</div>
            <div class="col-lg-3">{{ $t('legalInfo') }}</div>
            <div class="col-lg-3">{{ $t('statusAndTimeline') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <!-- ===== CỘT 1: KHÁCH HÀNG + ĐƠN HÀNG ===== -->
            <div class="col-lg-4">
              <div v-if="item.client" class="d-flex align-items-start">
                <div class="kyc-avatar mr-3"
                     :class="item.type === 'enterprise' ? 'kyc-avatar--enterprise' : 'kyc-avatar--personal'">
                  <i v-if="item.type === 'enterprise'" class="fa fa-building"></i>
                  <i v-else-if="item.type === 'personal'" class="fa fa-user"></i>
                  <i v-else class="fa fa-question"></i>
                </div>
                <div class="flex-grow-1 min-width-0">
                  <p class="font-weight-bold mb-1 text-truncate" :title="item.client.companyName">
                    {{ item.client.companyName }}
                  </p>
                  <p class="mb-1">
                    <code class="domain-tag">{{ item.client.domain }}</code>
                    <span v-if="item.type === 'enterprise'" class="badge badge-primary ml-1">{{ $t('enterprise') }}</span>
                    <span v-else-if="item.type === 'personal'" class="badge badge-secondary ml-1">{{ $t('personal') }}</span>
                  </p>
                  <p class="text-muted mb-1" v-if="item.sales || item.account">
                    <span v-if="item.sales" :title="$t('sales')">
                      <i class="fa fa-user-tie"></i> {{ item.sales.name }}
                    </span>
                    <span v-if="item.account" :title="$t('account')" class="ml-2">
                      <i class="fa fa-headset"></i> {{ item.account.name }}
                    </span>
                  </p>
                  <!-- Đơn hàng (gộp) -->
                  <div class="kyc-orders mt-2 pt-2 border-top">
                    <template v-if="item.packageStats && item.packageStats.count">
                      <p class="mb-1">
                        <i class="fa fa-shopping-bag text-success mr-1"></i>
                        <b class="text-success">{{ item.packageStats.count }} {{ $t('orders') }}</b>
                        <span v-if="item.packageStats.firstStartTime" class="text-muted ml-2">
                          {{ $t('firstOrder') }}: {{ item.packageStats.firstStartTime | moment('DD/MM/YY') }}
                        </span>
                      </p>
                      <p v-if="item.packageStats.totalAmount" class="text-primary font-weight-bold mb-0">
                        {{ formatVND(item.packageStats.totalAmount) }}
                        <span v-if="item.packageStats.firstMonthCount" class="text-muted font-weight-normal ml-1">
                          ({{ item.packageStats.firstMonthCount }} {{ $t('months') }})
                        </span>
                      </p>
                    </template>
                    <p v-else class="text-muted mb-0">
                      <i class="fa fa-shopping-bag mr-1"></i>{{ $t('noOrder') }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else class="text-secondary">{{ $t('unknown') }}</div>
            </div>

            <!-- ===== CỘT 2: PHÁP LÝ ===== -->
            <div class="col-lg-3">
              <template v-if="item.type === 'enterprise'">
                <p class="mb-1">
                  <span v-if="item.companyName" class="font-weight-bold">{{ item.companyName }}</span>
                  <span v-else class="text-warning"><i class="fa fa-exclamation-triangle"></i> {{ $t('missingCompanyName') }}</span>
                  <span v-if="item.shortName" class="text-muted ml-1">({{ item.shortName }})</span>
                </p>
                <p class="mb-1 text-muted">
                  <span v-if="item.companyTaxCode"><i class="fa fa-receipt mr-1"></i>{{ item.companyTaxCode }}</span>
                  <span v-else class="text-warning"><i class="fa fa-receipt mr-1"></i>{{ $t('missingTaxCode') }}</span>
                </p>
                <p class="mb-1">
                  <i class="fa fa-user text-muted mr-1"></i>
                  <span v-if="item.name">{{ item.name }}</span>
                  <span v-else class="text-warning">{{ $t('missingName') }}</span>
                  <span v-if="item.position" class="text-muted">, {{ item.position }}</span>
                </p>
              </template>
              <template v-else-if="item.type === 'personal'">
                <p class="mb-1">
                  <i class="fa fa-user text-muted mr-1"></i>
                  <span v-if="item.name" class="font-weight-bold">{{ item.name }}</span>
                  <span v-else class="text-warning">{{ $t('missingName') }}</span>
                </p>
                <p class="mb-1 text-muted" v-if="item.taxCode">
                  <i class="fa fa-receipt mr-1"></i>{{ item.taxCode }}
                </p>
              </template>
              <p v-if="item.contractNumber" class="mb-1">
                <i class="fa fa-hashtag text-muted mr-1"></i>
                <b class="text-primary">{{ item.contractNumber }}</b>
              </p>
              <validation-badge :item="item" class="d-inline-block" />
            </div>

            <!-- ===== CỘT 3: TRẠNG THÁI + TIME ===== -->
            <div class="col-lg-3">
              <p class="mb-2">
                <span v-if="item.cancelTime" class="badge badge-danger">
                  <i class="fa fa-times-circle mr-1"></i>{{ $t('canceled') }}
                </span>
                <span v-else-if="item.sendContractTime" class="badge badge-success">
                  <i class="fa fa-paper-plane mr-1"></i>{{ $t('sentContract') }}
                </span>
                <span v-else-if="item.confirmTime" class="badge badge-primary">
                  <i class="fa fa-check-circle mr-1"></i>{{ $t('confirmed') }}
                </span>
                <span v-else class="badge badge-warning">
                  <i class="fa fa-clock mr-1"></i>{{ $t('waiting') }}
                </span>
              </p>
              <p class="text-muted mb-1">
                <i class="fa fa-calendar-plus mr-1"></i>{{ $t('createdShort') }}:
                {{ item.createTime | moment('DD/MM/YY HH:mm') }}
                <span class="ml-1">({{ formatTimeAgo(item.createTime) }})</span>
              </p>
              <p v-if="item.sendContractTime" class="text-success mb-1">
                <i class="fa fa-paper-plane mr-1"></i>{{ item.sendContractTime | moment('DD/MM/YY HH:mm') }}
                <span v-if="item.sentContractBy" class="text-muted">— {{ item.sentContractBy.name }}</span>
              </p>
              <p v-else-if="item.cancelTime" class="text-danger mb-1">
                <i class="fa fa-times-circle mr-1"></i>{{ item.cancelTime | moment('DD/MM/YY HH:mm') }}
                <span v-if="item.canceledBy" class="text-muted">— {{ item.canceledBy.name }}</span>
              </p>
              <p v-else-if="item.confirmTime" class="text-primary mb-1">
                <i class="fa fa-check-circle mr-1"></i>{{ item.confirmTime | moment('DD/MM/YY HH:mm') }}
                <span v-if="item.confirmedBy" class="text-muted">— {{ item.confirmedBy.name }}</span>
              </p>
              <p v-if="item.note" class="text-muted font-italic mt-1 note-truncate mb-0" :title="item.note">
                <i class="fa fa-quote-left mr-1"></i>{{ item.note }}
              </p>
            </div>

            <!-- ===== CỘT 4: ACTIONS ===== -->
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button
                        v-if="!item.confirmTime && !item.cancelTime && ['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager'].includes($store.state.user.role)"
                        class="btn btn-sm btn-warning ml-1"
                        @click="$refs.kycForm.update(item._id)">
                      <font-awesome-icon icon="gavel" />&nbsp;{{ $t('reviewProfile') }}
                    </button>
                    <button
                        v-else-if="['owner', 'admin', 'tech', 'account', 'accountant', 'operationsManager', 'lookup', 'sales', 'am'].includes($store.state.user.role)"
                        class="btn btn-sm btn-outline-info is-border-1 ml-1"
                        @click="$refs.kycForm.update(item._id)">
                      <font-awesome-icon icon="folder-open" />&nbsp;{{ $t('viewProfile') }}
                    </button>
                    <button
                        v-if="item.type && ['owner', 'admin', 'tech', 'operationsManager', 'account', 'accountant', 'sales'].includes($store.state.user.role)"
                        class="btn btn-sm btn-success ml-1"
                        @click="$refs.exportContract.open(item._id)"
                        :title="$t('exportContractTooltip')">
                      <font-awesome-icon icon="file-pdf" />&nbsp;{{ $t('exportContract') }}
                    </button>
                    <button
                        v-if="['owner', 'tech', 'operationsManager', 'account', 'accountant'].includes($store.state.user.role)"
                        class="btn btn-sm btn-primary ml-1"
                        @click="$refs.sendContract.update(`${item._id}?populateClient=true`)">
                      <font-awesome-icon icon="file-upload" />&nbsp;{{ $t('contract') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
          v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load">
        </b-pagination>
      </div>
    </div>
    <k-y-c-form ref="kycForm"></k-y-c-form>
    <send-contract ref="sendContract"></send-contract>
    <export-contract-modal ref="exportContract"></export-contract-modal>
  </main>
</template>

<script>
import List from '@/mixins/List';
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import ClientSelect from "@/components/ClientSelect.vue";
import SendContract from "./SendContract";
import KYCForm from './KYCForm';
import moment from 'moment';
import AdminUserSelect from "@/components/AdminUserSelect.vue";
import KYCExport from "@/views/client/client-kyc/KYCExport.vue";
import ExportContractModal from "./ExportContractModal";

export default {
  components: {
    AdminUserSelect,
    SendContract,
    ClientSelect,
    TimeRangePicker,
    KYCForm,
    KYCExport,
    ExportContractModal,
    'validation-badge': {
      props: ['item'],
      computed: {
        validation() {
          const m = this.item || {};
          const errors = [];
          if (!m.type) errors.push('type');
          if (!m.IDFront) errors.push('IDFront');
          if (!m.IDBack) errors.push('IDBack');
          if (!m.owner) errors.push('owner');
          if (m.type === 'enterprise') {
            if (!m.businessRegistration) errors.push('businessRegistration');
            if (!m.companyName) errors.push('companyName');
            if (!m.companyTaxCode) errors.push('companyTaxCode');
            if (!m.companyAddress) errors.push('companyAddress');
            if (!m.position) errors.push('position');
          } else if (m.type === 'personal') {
            if (!m.proofOfAddress) errors.push('proofOfAddress');
          }
          if (!m.name) errors.push('name');
          if (!m.address) errors.push('address');
          if (!m.callScript) errors.push('callScript');
          if (m.invoiceEnabled && (!m.invoiceEmails || !m.invoiceEmails.length)) errors.push('invoiceEmails');
          return errors;
        }
      },
      template: `
        <span>
          <span v-if="validation.length === 0" class="badge badge-success">
            <i class="fa fa-check-circle"></i> Đầy đủ
          </span>
          <span v-else class="badge badge-danger" :title="'Thiếu: ' + validation.join(', ')">
            <i class="fa fa-exclamation-circle"></i> Thiếu {{ validation.length }} thông tin
          </span>
        </span>
      `
    },
  },
  props: ['client'],
  mixins: [List],
  data: function () {
    return {
      service: '/client-kyc',
      reloadBus: 'reloadKYC',
      defaultFilterFormModel: {
        status: null,
        type: null,
        keyword: null,
        client: this.client ? this.client._id : null,
        sales: null,
        account: null,
      },
      statusOptions: [
        { value: null, text: this.$t('selectStatus') },
        { value: 1, text: this.$t('waiting') },
        { value: 2, text: this.$t('canceled') },
        { value: 3, text: this.$t('confirmed') },
        { value: 4, text: this.$t('sentContract') },
      ],
    }
  },
  methods: {
    calcBockTime(confirmTime) {
      return 30 - moment().diff(moment(confirmTime), 'days');
    },
    formatTimeAgo(timestamp) {
      if (!timestamp) return '';
      const diff = moment().diff(moment(timestamp));
      const minutes = Math.floor(diff / 60000);
      if (minutes < 1) return this.$t('justNow');
      if (minutes < 60) return this.$t('minutesAgo', [minutes]);
      const hours = Math.floor(minutes / 60);
      if (hours < 24) return this.$t('hoursAgo', [hours]);
      const days = Math.floor(hours / 24);
      if (days < 30) return this.$t('daysAgo', [days]);
      const months = Math.floor(days / 30);
      return this.$t('monthsAgo', [months]);
    },
    formatVND(num) {
      if (num == null || isNaN(num)) return '';
      return Number(num).toLocaleString('vi-VN') + ' đ';
    },
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        title: "Client profile",
        confirmTime: 'Confirm time',
        time: 'Time',
        createdBy: "Created by",
        customer: "Customer",
        personal: "Personal",
        enterprise: "Enterprise",
        selectCustomerType: "Select customer type",
        canceled: "Canceled",
        confirmed: "Confirmed",
        sentContract: "Sent contract",
        blockTime: "Block time",
        blockTimeNote: "From the time of confirmation, if after 30 days have not been approved, the account will be locked",
        cancelTime: "Cancel time",
        sendContractTime: "Send contract time",
        reason: 'Reason',
        sentContractBy: "Sent contract by",
        canceledBy: "Canceled by",
        confirmedBy: "Confirmed by",
        invoiceInformation: "invoice information",
        address: "Address",
        taxCode: "Tax code",
        invoiceEmails: "Email receipt invoice",
        confirmAndSendContract: "Confirm and send contract",
        sendContract: "Send contract",
        contract: "Contract",
        profile: "Hồ sơ",
        updatedBy: "Updated by",
        chooseSales: "Choose sales",
        chooseAccount: "Choose account",
        account: "Account",
        selectStatus: "Select status",
        exportContract: "Export PDF",
        exportContractTooltip: "Export contract as PDF/DOCX from template",
        legalInfo: "Legal info",
        statusAndTimeline: "Status & Timeline",
        actions: "Actions",
        reviewProfile: "Review profile",
        viewProfile: "View profile",
        contractNumber: "Contract no.",
        contractNumberNotExported: "Not exported yet",
        missingCompanyName: "Missing company name",
        missingTaxCode: "Missing tax code",
        missingName: "Missing name",
        createdShort: "Created",
        justNow: "just now",
        minutesAgo: "{0} min ago",
        hoursAgo: "{0}h ago",
        daysAgo: "{0}d ago",
        monthsAgo: "{0}mo ago",
        orderInfo: "Order info",
        orders: "orders",
        firstOrder: "First",
        months: "months",
        noOrder: "No order yet",
      },
      vi: {
        title: "Hồ sơ khách hàng",
        confirmTime: 'Xác nhận lúc',
        time: 'Thời gian',
        createdBy: "Tạo bởi",
        customer: "Khách hàng",
        personal: "Cá nhân",
        enterprise: "Doanh nghiệp",
        selectCustomerType: "Chọn loại khách hàng",
        canceled: "Bị từ chối",
        confirmed: "Đã xác nhận",
        sentContract: "Hoàn thành hợp đồng",
        blockTime: "Khách sẽ bị khoá nếu không kí hợp đồng sau",
        blockTimeNote: "Kể từ thời gian xác nhận hồ sơ, nếu sau 30 ngày chưa được duyệt tài khoản sẽ bị khoá",
        cancelTime: "Từ chối lúc",
        sendContractTime: "Gửi hợp đồng lúc",
        reason: 'Lý do',
        sentContractBy: "Người gửi hợp đồng",
        canceledBy: "Người từ chối",
        confirmedBy: "Người xác nhận",
        invoiceInformation: "Thông tin xuất hoá đơn",
        address: "Địa chỉ",
        taxCode: "Mã số thuế",
        invoiceEmails: "Email nhận hoá đơn",
        confirmAndSendContract: "Xác nhận và gửi hợp đồng",
        sendContract: "Gửi hợp đồng",
        contract: "Hợp đồng",
        profile: "Hồ sơ",
        updatedBy: "Cập nhật bởi",
        chooseSales: "Chọn sales",
        chooseAccount: "Chọn chăm sóc",
        account: "Chăm sóc",
        selectStatus: "Chọn trạng thái",
        exportContract: "Xuất PDF",
        exportContractTooltip: "Xuất hợp đồng PDF/DOCX từ mẫu",
        legalInfo: "Thông tin pháp lý",
        statusAndTimeline: "Trạng thái & Thời gian",
        actions: "Hành động",
        reviewProfile: "Duyệt hồ sơ",
        viewProfile: "Xem hồ sơ",
        contractNumber: "Số HĐ",
        contractNumberNotExported: "Chưa xuất hợp đồng",
        missingCompanyName: "Thiếu tên công ty",
        missingTaxCode: "Thiếu MST",
        missingName: "thiếu họ tên",
        createdShort: "Tạo",
        justNow: "vừa xong",
        minutesAgo: "{0} phút trước",
        hoursAgo: "{0} giờ trước",
        daysAgo: "{0} ngày trước",
        monthsAgo: "{0} tháng trước",
        orderInfo: "Đơn hàng",
        orders: "đơn",
        firstOrder: "Đơn đầu",
        months: "tháng",
        noOrder: "Chưa có đơn",
      }
    }
  }
}
</script>

<style scoped>
.kyc-table {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e3e6f0;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.kyc-table__head {
  background: #f8f9fc;
  border-bottom: 2px solid #e3e6f0;
  padding: 10px 16px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
}
.kyc-table__body .kyc-row {
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s ease;
}
.kyc-table__body .kyc-row:last-child {
  border-bottom: none;
}
.kyc-table__body .kyc-row:hover {
  background-color: #f8f9fc;
}
.kyc-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  flex-shrink: 0;
}
.kyc-avatar--enterprise {
  background: #e3f2fd;
  color: #1976d2;
}
.kyc-avatar--personal {
  background: #f3e5f5;
  color: #7b1fa2;
}
.min-width-0 {
  min-width: 0;
}
.kyc-row .small {
  line-height: 1.6;
}
.domain-tag {
  background: #f1f3f5;
  color: #495057;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 0.78rem;
}
.note-truncate {
  max-height: 36px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
